// extracted by mini-css-extract-plugin
export var modal = "_jf-0";